import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { didNotFindOptionsShape } from '@bibliocommons/bc-prop-types';

import { CHAT_WIDGET_ID } from 'app/constants/LibraryConstants';

export const orderedSearchTypesShape = ImmutablePropTypes.listOf(
  PropTypes.oneOf(['author', 'bkw', 'series', 'smart', 'subject', 'tag', 'title', 'user', 'userlist'])
);

// slowly replacing Glue's libraryShape with this one
// add props as they are needed by components
export default ImmutablePropTypes.mapContains({
  chatWidgets: ImmutablePropTypes.mapOf(
    ImmutablePropTypes.mapContains({
      enabled: PropTypes.bool.isRequired
    }),
    PropTypes.oneOf(Object.values(CHAT_WIDGET_ID))
  ),
  didNotFindOptions: didNotFindOptionsShape.isRequired,
  orderedSearchTypes: orderedSearchTypesShape.isRequired,
  searchTipsLink: PropTypes.string,
  showExternalSearchLink: PropTypes.bool,
  singleBranch: PropTypes.bool.isRequired
});
